import { ArnIfComponent } from '../if/ArnIfComponent';

export class ArnIfIsComponent extends ArnIfComponent {
  static readonly ATTR_WHITELIST = 'listed-in';
  static readonly ATTRS = [ArnIfIsComponent.ATTR_WHITELIST];

  static override get observedAttributes() {
    return ArnIfIsComponent.ATTRS;
  }

  protected override setInitial() {
    super.setInitial(ArnIfIsComponent.ATTRS);
  }

  protected normalizeWhitelist(tag: string): string {
    let normalized = tag.trim();
    while (['"', ' ', "'"].includes(normalized.charAt(0))) {
      normalized = normalized.substring(1);
    }
    while (['"', ' ', "'"].includes(normalized.charAt(normalized.length - 1))) {
      normalized = normalized.substring(0, normalized.length - 1);
    }
    return normalized.trim();
  }

  override attributeChangedCallback(
    name: string,
    _oldValue: string | null,
    newValue: string | null
  ) {
    switch (name) {
      case ArnIfIsComponent.ATTR_WHITELIST:
        {
          const whitelists = this.getWhitelistsFromAttribute(newValue);
          this.setWhitelists(...whitelists);
        }
        break;
    }
  }

  protected override updateUI(isTrue: boolean) {
    super.updateUI(isTrue);
  }

  protected getWhitelistsFromAttribute(whitelistAttr: string | null): string[] {
    return whitelistAttr
      ? whitelistAttr.split(',').map(this.normalizeWhitelist)
      : [];
  }

  async setWhitelists(...whitelists: string[]) {
    const isWhitelisted =
      whitelists.length > 0
        ? await this.arnClient.condition.user.isListedIn(...whitelists)
        : false;
    this.updateUI(isWhitelisted);
  }
}

const name = 'arn-if-is';
if (!window.customElements.get(name)) {
  window.customElements.define(name, ArnIfIsComponent);
}
